
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freshwater-algae/[category]/[name]",
      function () {
        return require("private-next-pages/freshwater-algae/[category]/[name].js");
      }
    ]);
  